export default __webpack_public_path__ + "affinity-groups-logo.svg";